import { useState,useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './auth/Login';
import Signup from './auth/Signup';
import ForgotPassword from './auth/ForgotPassword';
import CloverCallback from './auth/CloverCallback';
import CloverIntegration from './auth/CloverIntegration';
import MainLayout from './layout';
import Dashboard from './dashboard';
import { Analytics } from './analytics';
import { CampaignIdeas } from './campaingIdeas';
import { Playground } from './playGround';
import { Integrations } from './integrations';
import { Demographics } from './demographics';
import { MenuEnhancement } from './menuEnhancement';
import { MarketingCalendar } from './marketingCampaign';
import ReviewAnalysis from './reviewAnalysis';
import CompetitorPromotions from './competitorPromotions';
import Competitors from './competitors';
import UpcomingEvents from './upcomingEvents';
import CampaignGenerator from './campaignGenerator';
import Campaigns from './campaigns';
import Menu from './menu';
import { GetStarted, Processing } from './launching';
import { useLocalStorageSync } from '../hooks/useLocalStorageSync'
import { useRestaurantNav } from '../hooks/useRestaurantNav'
import { useCloverIntegration } from '../hooks/useCloverIntegration'
import GlobalLoaders from '../components/common/GlobalLoaders'

const AppWrapper = () => {
    useLocalStorageSync();
    const { navigate } = useRestaurantNav();
    const { loading, showMenuLoader, status, cloverError, hasError  } = useCloverIntegration();
    const [displayLoader, setDisplayLoader] = useState(false);
  
    useEffect(() => {
      if (showMenuLoader) {
        setDisplayLoader(true);
      } else if (!showMenuLoader && displayLoader) {
        const timer = setTimeout(() => {
          setDisplayLoader(false);
          navigate("/generate");
        }, 2000);
  
        return () => clearTimeout(timer);
      }
    }, [showMenuLoader, displayLoader]);
  return (
    <>
      <GlobalLoaders
        integrationLoading={loading}
        menuLoading={displayLoader}
        menuStatus={status}
        cloverError={cloverError}
        hasError={hasError}
      />
        <Routes>
          {/* Auth Routes - No sidebar */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/integrate-clover" element={<CloverIntegration />} />
          <Route path="/clover/callback" element={<CloverCallback />} />
          <Route path="/generate" element={<GetStarted />} />
          <Route path="/processing" element={<Processing />} />
          <Route element={<MainLayout />}>
          <Route path="/:restaurantId/dashboard" element={<Dashboard />} />
          <Route path="/:restaurantId/analytics" element={<Analytics />} />
          <Route path="/:restaurantId/campaign-ideas" element={<CampaignIdeas />} />
          <Route path="/:restaurantId/flyer" element={<Playground />} />
          <Route path="/:restaurantId/integrations" element={<Integrations />} />
          <Route path="/:restaurantId/integrations/:integrationName" element={<Integrations />} />
          <Route path="/:restaurantId/demographics" element={<Demographics />} />
          <Route path="/:restaurantId/menu-enhancement" element={<MenuEnhancement />} />
          <Route path="/:restaurantId/marketing-calendar" element={<MarketingCalendar />} />
          <Route path="/:restaurantId/review-analysis" element={<ReviewAnalysis />} />
          <Route path="/:restaurantId/competitor-promotions" element={<CompetitorPromotions />} />
          <Route path="/:restaurantId/competitors" element={<Competitors />} />
          <Route path="/:restaurantId/upcoming-events" element={<UpcomingEvents />} />
          <Route path="/:restaurantId/campaigns" element={<Campaigns />} />
          <Route path="/:restaurantId/campaign-generator" element={<CampaignGenerator />} />
          <Route path="/:restaurantId/menu" element={<Menu />} />
         
          </Route>
          {/* Catch all - redirect to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
     
    </>
  );
};

export default AppWrapper;
